
import { motion } from 'framer-motion';

export default function CinematicIntro() {
  return (
    <motion.div
      className="fixed inset-0 z-[9999] bg-[#050505] flex items-center justify-center"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1, delay: 0.5 }}
    >
      <div className="text-center px-6">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.5, ease: 'easeOut' }}
          className="mb-6 sm:mb-8"
        >
          <img
            src="https://public.readdy.ai/ai/img_res/39d6fbca-b681-4c48-84eb-ab94b5a74e78.png"
            alt="EUREKA Logo"
            className="h-16 sm:h-24 mx-auto"
          />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1 }}
          className="text-4xl sm:text-6xl font-bold text-white mb-3 sm:mb-4"
          style={{ fontFamily: 'Orbitron, sans-serif' }}
        >
          EUREKA
        </motion.h1>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 2 }}
          className="text-[#00E5FF] text-sm sm:text-xl tracking-[0.2em] sm:tracking-[0.3em] uppercase"
          style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
        >
          Engineering Precision Since 1989
        </motion.div>

        <motion.div
          initial={{ width: 0 }}
          animate={{ width: '150px' }}
          transition={{ duration: 1.5, delay: 2.5 }}
          className="h-[1px] bg-gradient-to-r from-transparent via-[#00E5FF] to-transparent mx-auto mt-6 sm:mt-8 sm:!w-[200px]"
        />
      </div>
    </motion.div>
  );
}
